import { API_URL, authFetch } from "../../api_calls.js";

function normalizeIdentifier(value) {
  return typeof value === "string" ? value.trim() : "";
}

function buildUserServiceError(message, status) {
  const error = new Error(message);
  if (typeof status === "number") {
    error.status = status;
  }
  return error;
}

export function getAuthenticatedUserIdentifier(authUser) {
  const candidates = [
    authUser?.tokenParsed,
    authUser?.idTokenParsed,
    authUser,
  ];

  for (const candidate of candidates) {
    const identifier =
      normalizeIdentifier(candidate?.preferred_username) ||
      normalizeIdentifier(candidate?.username) ||
      normalizeIdentifier(candidate?.email).toLowerCase();

    if (identifier) {
      return identifier;
    }
  }

  return "";
}

export async function getUserProfileByIdentifier(userId) {
  const identifier = normalizeIdentifier(userId);
  if (!identifier) {
    throw buildUserServiceError("Missing user identifier");
  }

  const response = await authFetch(`${API_URL}/users/${encodeURIComponent(identifier)}`);

  if (!response.ok) {
    throw buildUserServiceError(
      `User profile request failed with HTTP ${response.status}`,
      response.status
    );
  }

  return response.json();
}

export async function getCurrentUserProfile(authUser) {
  const identifier = getAuthenticatedUserIdentifier(authUser);
  if (!identifier) {
    throw buildUserServiceError("Missing authenticated user identifier");
  }

  return getUserProfileByIdentifier(identifier);
}

export async function getCurrentUserMongoId(authUser) {
  const user = await getCurrentUserProfile(authUser);
  return user?._id || null;
}
